export default __webpack_public_path__ + "static/media/sign-in-image.6c7716df.png";